jQuery(document).ready(function($){

    function loadVacatures() {
        var functie = $("#functie").val();
        var functieText = $("#functie option:selected").text();
        var keyword = $("#keyword").val();
        var hours = $("#hours").val();
        var hoursText = $("#hours option:selected").text();
        $("#page_no").val(1);

        var pageNo = $("#page_no").val();
        var str = '&pageNo=' + pageNo +  '&functie=' + functie + '&keyword=' + keyword + '&hours=' + hours + '&action=vacature_filter';

        if(functie !== "") {
            $(".selected_function").show();
            $(".functie_text").text(functieText);
        } else {
            $(".selected_function").hide();
            $(".functie_text").text("");
        }
		
		if(hours !== "") {
            $(".selected_hours").show();
            $(".hours_text").text(hoursText);
        } else {
            $(".selected_hours").hide();
            $(".hours_text").text("");
        }

        $.ajax({
            type: 'POST',
            url: '/wp/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: str,

            success: function(data) {
                $(".all_vacature").html(data.html);				
            }
        });
    }

    $('#functie, #hours, #keyword').on('change keyup', function () {
        loadVacatures();
    });

    $('.clear_functie').on('click', function () {
        $('#functie').val('').trigger('change');
        $(".selected_function").hide(); 
        loadVacatures(); 
    });
    
    $('.clear_hours').on('click', function () {
        $('#hours').val('').trigger('change');
        $(".selected_hours").hide(); 
        loadVacatures(); 
    });

});
